/**
 * Length of the emailed sign-in code.
 *
 * MUST match Supabase → Authentication → Sign In / Providers → Email →
 * "Email OTP Length". If the two disagree the UI silently truncates the code
 * and every verification fails with "that code is not right", which is a
 * miserable thing to debug.
 *
 * Supabase's default is 6. Override with VITE_OTP_LENGTH if you change it there.
 */
const parsed = Number(import.meta.env.VITE_OTP_LENGTH);

export const OTP_LENGTH = Number.isInteger(parsed) && parsed >= 4 && parsed <= 10 ? parsed : 6;
